import { connect } from "react-redux";
import { Modal } from "reactstrap";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { msg } from "../../constants";

import { toggleAlert } from "../../store/alertbox/alertboxAction";

class Alertbox extends Component {
  onCloseModal = () => {
    this.props.toggleAlert("");
    if (this.props.message.isReload === '1') {
      // console.log('set Reload');
      window.location.reload();
    }
  };

  render() {
    // console.log('in Alertbox');
    // console.log(this.props);
    return (
      <Modal
        size="md"
        isOpen={this.props.isAlertOn}
        toggle={this.onCloseModal}
      >
        {this.props.message.isReload === '1' && (
          <div className="modal-header" style={{margin:'auto'}}>
            <h5 className="modal-title" id="exampleModalLongTitle">{msg.HeaderDocOrderApprove}</h5>
          </div>
        )}
        <div className="modal-content">
          <div className="modal-body">
            <p style={{ padding: "20px 20px 20px 20px" }} dangerouslySetInnerHTML={{ __html: this.props.message.message }}>
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cf btn-sm"
              onClick={this.onCloseModal}
              style={{ margin: "auto" }}
            >
              ตกลง
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

Alertbox.propTypes = {
  isAlertOn: PropTypes.bool,
  message: PropTypes.string,
  toggleAlert: PropTypes.func
};

const mapStateToProps = state => ({
  isAlertOn: state.alertbox.isAlertOn,
  message: state.alertbox.message,
});

export default connect(
  mapStateToProps,
  {
    toggleAlert
  }
)(Alertbox);
